import React from 'react';
type LogoStripProps = {
  id: string;
  title: string;
  subtitle?: string;
  count: number;
};
export function LogoStrip({
  id,
  title,
  subtitle,
  count
}: LogoStripProps) {
  return <section className="w-full bg-white py-20" aria-labelledby={id} data-id="element-334" data-mp="1f7fvxphucu4t">
      <div className="mx-auto max-w-shell px-6 text-center" data-id="element-335" data-mp="1f98sgbyqpxz3">
        <h2 id={id} className="display text-[26px] font-semibold text-ink sm:text-[32px]" data-id="element-336" data-mp="1j7q2b39jpmk7">
          {title}
        </h2>
        {subtitle && <p className="mx-auto mt-3 max-w-[520px] text-[16px] text-ink-muted" data-id="element-337" data-mp="15f9t1kq1wsau">{subtitle}</p>}
        <ul className="mt-10 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6" data-id="element-338" data-mp="1a9e0s67554cz">
          {Array.from({
          length: count
        }, (_, i) => <li key={i} className="flex h-20 items-center justify-center rounded-[12px] border border-dashed border-ink/15 bg-canvas-warm text-[13px] font-medium text-ink-muted" data-id="element-339" data-mp="10i05ybq4wsq6">
              Partner logo
            </li>)}
        </ul>
      </div>
    </section>;
}